var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#6415ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217-465h113q15 0 27.5 7.5T377-436l23 45 103-205q15-29 47.5-29t47.5 29l65 131h80q-19-93-92-154t-171-61q-98 0-171 61t-92 154Zm263 320q98 0 171-61t92-153H630q-15 0-27.5-7.5T583-388l-23-45-103 204q-15 29-47.5 30T362-228l-65-131h-80q19 92 92 153t171 61Zm0 126q-82 0-153.5-31t-125-84Q148-187 117-258.5T86-412h126q0 112 78 189.5T480-145q112 0 190-77.5T748-412h126q0 82-31 153.5T758.5-134q-53.5 53-125 84T480-19ZM86-412q0-82 31-153.5t84.5-125Q255-744 326.5-775T480-806q64 0 125 20t112 59l68-68 79 79-68 68q39 51 58.5 111.5T874-412H748q0-112-78-190t-190-78q-112 0-190 78t-78 190H86Zm243-428v-111h302v111H329Zm151 695q-112 0-190-77.5T212-412q0-112 78-190t190-78q112 0 190 78t78 190q0 112-78 189.5T480-145Zm0-267Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgTime);
export default __webpack_public_path__ + "static/media/avg-time.64e6c05a4edbeba871010ecd1b404b0c.svg";
export { ForwardRef as ReactComponent };